import SectionTitle from '@/components/feature/SectionTitle';
import { highlights } from '@/mocks/manga';

export default function Highlights() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionTitle
          align="center"
          kicker="作品看点"
          title="为什么这么多人被它打动"
          desc="笑点、糖分与治愈感恰到好处，是这部作品能让人一口气追下去的理由。"
        />
        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {highlights.map((h) => (
            <div key={h.title} className="flex gap-4 rounded-lg bg-background-50 p-5">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className={`${h.icon} text-xl`}></i>
              </span>
              <div>
                <h3 className="font-heading text-base text-foreground-900">{h.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{h.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}